export default __webpack_public_path__ + "static/media/SpecialDays_06.62dfbd68.png";